import { ModalProps } from '@mantine/core';
import styled from 'styled-components';

export const holdingTransactionsModalStyles: ModalProps['styles'] = {
	content: { minHeight: '600px' },
	header: { padding: '1rem' },
	body: { padding: '0 1rem 1rem' },
};

export const VestingTermFormStyles = styled.form`
	width: 100%;

	.panel {
		display: flex;
		flex-direction: column;
		padding: 1rem;
		background-color: ${({ theme }) => theme.v3.colors.white[0]};
	}
`;
